import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Comment from "../components/comment";
export default {
  data: function data() {
    return {
      form: [],
      List: [],
      infoObj: [],
      comm: 0,
      CommentList: [],
      Token: '',
      commentText: '',
      // 评论内容
      TotalComments: 1000,
      // 评论总条数
      checked: false,
      // 是否匿名发表
      cc: '',
      NickyName: "",
      aa: '',
      previos: '',
      naxt: '',
      idnode: -1,
      issue: '',
      text: [],
      idnext: -1,
      bb: '',
      Title: '',
      newArr: [],
      actor: [],
      Unit: [],
      Unit_EngLish: [],
      key: [],
      Comments: '',
      keyEng: [],
      id: '',
      title: '',
      ida: '',
      indoe: "",
      inext: "",
      kind: 4,
      a: '',
      name: '',
      CanReview: false,
      isComment: false,
      isEnzhaiy: false,
      ISSN: "",
      CN: "",
      Itmtitle: '',
      path: '',
      setName: "",
      centerDialogVisible: false,
      codeId: 0
    };
  },
  components: {
    Comment: Comment
  },
  mounted: function mounted() {
    var _this2 = this;

    var id = this.$route.query.ArticleID;
    this.id = this.$route.query.ArticleID;

    this._getPLLB(id);

    if (sessionStorage.getItem("SetItem")) {
      var SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map(function (item) {
        if (item.SetItemID == 230) {
          item.Item_Value == "是" ? _this2.isComment = true : _this2.isComment = false;
        }

        if (item.SetItemID == 6055) {
          item.Item_Value == "是" ? _this2.isEnzhaiy = true : _this2.isEnzhaiy = false;
        }

        if (item.SetItemID == 5000) {
          _this2.ISSN = item.Item_Value;
        }

        if (item.SetItemID == 5010) {
          _this2.CN = item.Item_Value;
        }

        if (item.SetItemID == 1000) {
          _this2.Itmtitle = item.Item_Value;
        }

        if (item.SetItemID == 6018) {
          if (item.Item_Value == "是") {
            //  if(this.$route.query.scriptID){
            _this2.path = '_GetScriptPrePrintDetailed'; //   }else{
            //     this.path='_getLBXQ'
            //   }
          } else {
            //  if(this.$route.query.scriptID){
            //     this.path='_GetScriptPrePrintDetailed'
            //   }else{
            _this2.path = '_getLBXQ'; //   }
          }

          _this2.getLBXQ();
        }
      });
    } else {
      var params = [1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960, 310, 12];
      this.$store.dispatch("_getSet", params).then(function (res) {
        _this2.SetItem = res.data.Data;
        sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));

        _this2.SetItem.map(function (item) {
          if (item.SetItemID == 230) {
            item.Item_Value == "是" ? _this2.isComment = true : _this2.isComment = false;
          }

          if (item.SetItemID == 6055) {
            item.Item_Value == "是" ? _this2.isEnzhaiy = true : _this2.isEnzhaiy = false;
          }

          if (item.SetItemID == 5000) {
            _this2.ISSN = item.Item_Value;
          }

          if (item.SetItemID == 5010) {
            _this2.CN = item.Item_Value;
          }

          if (item.SetItemID == 1000) {
            _this2.Itmtitle = item.Item_Value;
          }

          if (item.SetItemID == 6018) {
            if (item.Item_Value == "是") {
              if (_this2.$route.query.scriptID) {
                _this2.path = '_GetScriptPrePrintDetailed';
              } else {
                _this2.path = '_getLBXQ';
              }
            } else {
              if (_this2.$route.query.scriptID) {
                _this2.path = '_GetScriptPrePrintDetailed';
              } else {
                _this2.path = '_getLBXQ';
              }
            }

            _this2.getLBXQ();
          }
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  methods: {
    onSubmit: function onSubmit() {},
    _getPLLB: function _getPLLB(id) {
      var _this3 = this;

      var id = id;
      var params = {
        Type: 2,
        ID: id,
        PageSize: 3
      };
      var a = sessionStorage.getItem('aa');

      if (a == 1) {
        params.Type = 4;
      } else {
        params.Type = 2;
      }

      this.$store.dispatch("_getPLLB", params).then(function (res) {
        if (res.data.IsSuccess) {
          _this3.CommentList = res.data.Data;
          _this3.comm = res.data.ItemCount;
        }
      }).catch(function (err) {
        console.log("err", err);
      });
    },
    pdf: function pdf(i, size, guid, isoa) {
      var _this4 = this;

      var _this = this;

      if (!this.isdownb) {
        if (!isoa) {
          alert("只有登录用户才可以下载");
          return;
        } else {
          if (size <= 0) {
            "文件不存在";
            return;
          }
        }
      } else {
        if (size <= 0) {
          alert("文件不存在");
          return;
        }
      }

      this.$store.dispatch("_getPDFnew", {
        Id: guid
      }).then(function (Result) {
        if (Result.data.IsSuccess === false) {
          _this4.$message.error(Result.data.Message);
        } else {
          var Ids = Result.request.responseURL.split("Id=")[1];
          window.location = Result.config.baseURL + "/api/Web/OpenArticleFilebyGuidNew?Id=" + Ids;
        }
      });
    },
    annex: function annex(guid, isoa) {
      var _this5 = this;

      var _this = this;

      if (!this.isdownb) {
        if (!isoa) {
          alert("只有登录用户才可以下载");
          return;
        } else {
          if (guid == null) {
            "文件不存在";
            return;
          }
        }
      } else {
        if (guid == null) {
          alert("文件不存在");
          return;
        }
      }

      this.$store.dispatch("_OpenGUIDFile", {
        FileGUID: guid
      }).then(function (res) {
        if (res.data.IsSuccess) {
          _this5.$DownloadBase64File(res.data.Guid, 1);
        } else {
          _this5.$error(res.data.Message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getLBXQ: function getLBXQ() {
      var _this6 = this;

      var id = this.id;
      var time = new Date().getTime();
      var params = {
        Id: id,
        sec: time
      };
      this.$store.dispatch(this.path, params).then(function (res) {
        _this6.infoObj = res.data.Data;
        _this6.CanReview = res.data.Data.CanReview;
        _this6.Title = _this6.infoObj.Title;
        _this6.id = _this6.infoObj.ArticleID;
        var a = _this6.infoObj.IssueID;
        sessionStorage.setItem('a', a);
        document.title = res.data.Data.Title;

        if (res.data.Data.AuthorsHTML) {
          for (var num = 0; num < res.data.Data.AuthorsHTML.length; num++) {
            if (res.data.Data.AuthorsHTML.charAt(num) == ',') {
              if (res.data.Data.AuthorsHTML.charAt(num - 1) == '>') {
                res.data.Data.AuthorsHTML = _this6.changeStr(res.data.Data.AuthorsHTML, num, '#');
              }
            }
          }

          if (res.data.Data.AuthorsHTML.indexOf('#') != -1) {
            _this6.text = res.data.Data.AuthorsHTML.split("#");
          } else if (res.data.Data.AuthorsHTML.indexOf('、') != -1) {
            _this6.text = res.data.Data.AuthorsHTML.split("、");
          } else if (res.data.Data.AuthorsHTML.indexOf(';') != -1) {
            _this6.text = res.data.Data.AuthorsHTML.split(";");
          } else if (res.data.Data.AuthorsHTML.indexOf('；') != -1) {
            _this6.text = res.data.Data.AuthorsHTML.split("；");
          } else if (res.data.Data.AuthorsHTML.indexOf(' ;') != -1) {
            _this6.text = res.data.Data.AuthorsHTML.split(" ;");
          } else if (res.data.Data.AuthorsHTML.indexOf(',') != -1) {
            _this6.text = res.data.Data.AuthorsHTML.split(",");
          } else {
            _this6.text = res.data.Data.AuthorsHTML.split("，");
          }
        }

        if (res.data.Data.AuthorsHTMLE) {
          for (var num = 0; num < res.data.Data.AuthorsHTMLE.length; num++) {
            if (res.data.Data.AuthorsHTMLE.charAt(num) == ',') {
              if (res.data.Data.AuthorsHTMLE.charAt(num - 1) == '>') {
                res.data.Data.AuthorsHTMLE = _this6.changeStr(res.data.Data.AuthorsHTMLE, num, '#');
              }
            }
          }

          if (res.data.Data.AuthorsHTMLE) {
            if (res.data.Data.AuthorsHTMLE.indexOf('#') != -1) {
              _this6.actor = res.data.Data.AuthorsHTMLE.split("#");
            } else if (res.data.Data.AuthorsHTMLE.indexOf(', ') != -1) {
              _this6.actor = res.data.Data.AuthorsHTMLE.split(", ");
            } else if (res.data.Data.AuthorsHTMLE.indexOf('；') != -1) {
              _this6.actor = res.data.Data.AuthorsHTMLE.split("；");
            } else if (res.data.Data.AuthorsHTMLE.indexOf(';') != -1) {
              _this6.actor = res.data.Data.AuthorsHTMLE.split(";");
            } else if (res.data.Data.AuthorsHTMLE.indexOf('、') != -1) {
              _this6.actor = res.data.Data.AuthorsHTMLE.split("、");
            } else {
              _this6.actor = res.data.Data.AuthorsHTMLE.split("，");
            }
          }
        }

        if (res.data.Data.Unit) {
          if (res.data.Data.Unit.indexOf('#') != -1) {
            _this6.Unit = res.data.Data.Unit.split("#");
          } else if (res.data.Data.Unit.indexOf(', ') != -1) {
            _this6.Unit = res.data.Data.Unit.split(", ");
          } else if (res.data.Data.Unit.indexOf('；') != -1) {
            _this6.Unit = res.data.Data.Unit.split("；");
          } else if (res.data.Data.Unit.indexOf(';') != -1) {
            _this6.Unit = res.data.Data.Unit.split(";");
          } else if (res.data.Data.Unit.indexOf('、') != -1) {
            _this6.Unit = res.data.Data.Unit.split("、");
          } else {
            _this6.Unit = res.data.Data.Unit.split("，");
          }
        }

        if (res.data.Data.Unit_EngLish) {
          if (res.data.Data.Unit_EngLish.indexOf('#') != -1) {
            _this6.Unit_EngLish = res.data.Data.Unit_EngLish.split("#");
          } else if (res.data.Data.Unit_EngLish.indexOf(', ') != -1) {
            _this6.Unit_EngLish = res.data.Data.Unit_EngLish.split(", ");
          } else if (res.data.Data.Unit_EngLish.indexOf('；') != -1) {
            _this6.Unit_EngLish = res.data.Data.Unit_EngLish.split("；");
          } else if (res.data.Data.Unit_EngLish.indexOf(';') != -1) {
            _this6.Unit_EngLish = res.data.Data.Unit_EngLish.split(";");
          } else if (res.data.Data.Unit_EngLish.indexOf('、') != -1) {
            _this6.Unit_EngLish = res.data.Data.Unit_EngLish.split("、");
          } else {
            _this6.Unit_EngLish = res.data.Data.Unit_EngLish.split("，");
          }
        }

        if (res.data.Data.Keyword_Chinese) {
          res.data.Data.Keyword_Chinese = res.data.Data.Keyword_Chinese.replace(/<[^>]+>/g, "");

          if (res.data.Data.Keyword_Chinese.indexOf(',') != -1) {
            _this6.key = res.data.Data.Keyword_Chinese.split(",");
          } else if (res.data.Data.Keyword_Chinese.indexOf('、') != -1) {
            _this6.key = res.data.Data.Keyword_Chinese.split("、");
          } else if (res.data.Data.Keyword_Chinese.indexOf(';') != -1) {
            _this6.key = res.data.Data.Keyword_Chinese.split(";");
          } else if (res.data.Data.Keyword_Chinese.indexOf('；') != -1) {
            _this6.key = res.data.Data.Keyword_Chinese.split("；");
          } else if (res.data.Data.Keyword_Chinese.indexOf(' ;') != -1) {
            _this6.key = res.data.Data.Keyword_Chinese.split(" ;");
          } else {
            _this6.key = res.data.Data.Keyword_Chinese.split("，");
          }
        }

        if (res.data.Data.Keywords_English) {
          if (res.data.Data.Keywords_English.indexOf(',') != -1) {
            _this6.keyEng = res.data.Data.Keywords_English.split(",");
          } else if (res.data.Data.Keywords_English.indexOf('、') != -1) {
            _this6.keyEng = res.data.Data.Keywords_English.split("、");
          } else if (res.data.Data.Keywords_English.indexOf(';') != -1) {
            _this6.keyEng = res.data.Data.Keywords_English.split(";");
          } else if (res.data.Data.Keywords_English.indexOf('；') != -1) {
            _this6.keyEng = res.data.Data.Keywords_English.split("；");
          } else {
            _this6.keyEng = res.data.Data.Keywords_English.split("，");
          }
        }

        _this6.name = res.data.Data.AuthorsHTML;

        _this6._getNewlist();
      }).catch(function (err) {
        console.log(err);
      });
    },
    changeStr: function changeStr(str, index, _changeStr) {
      return str.substr(0, index) + _changeStr + str.substr(index + _changeStr.length);
    },
    copy: function copy() {
      var text = this.$refs.texta;
      var Url2 = this.$refs.texta.innerText;
      var oInput = document.createElement("input");
      oInput.value = Url2;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象

      document.execCommand("Copy"); // 执行浏览器复制命令

      oInput.className = "oInput";
      oInput.style.display = "none";
      alert("复制成功");
    },
    toSearch: function toSearch(e) {
      var put = e.target.innerText;

      if (put.indexOf('1') != -1) {
        var a = put.split('1')[0];
        var b = a;
        console.log(a);
      } else if (put.indexOf('2') != -1) {
        var a = put.split('2')[0];
        console.log(a);
        var b = a;
      } else if (put.indexOf('3') != -1) {
        var a = put.split('3')[0];
        console.log(a);
      } else {
        var a = put;
      }

      var b = a;
      console.log(b);
      var name = e.target.className;
      localStorage.setItem('value', b);

      if (b != '') {
        e.preventDefault();
        var routeUrl = this.$router.resolve({
          path: '/#/QuickSearch'
        });
        window.open(routeUrl.href, '_blank');
      }
    }
  }
};